/**
 * This module handles errors and show error and info messages.
 */
// msg constants for information message types
var G_MSG_TYPE_NORMAL = 0;
var G_MSG_TYPE_WARNING = 1;
var G_MSG_TYPE_ERROR = 2;
var G_MSG_TYPE_SUCCESS = 3;
var G_MAX_MSG_STRINGS = 3;

var VRC = VRC || {};

VRC.ErrorHandleService = (function(){

  /**
   * Different error types constants with code and messages
   * @private
   */
  var _errors = {
    NO_RESPONSE_FROM_SERVER : {
      code : 1,
      msg : 'We were unable to get any response at all from Wels Operator. Please check http://wellit.com/access-wels/ for messages from Wels regarding updates and other messages.' +
      'If no information is available please try again in a little while and/or contact support@wellit.no.'
    },
    DEFAULT : {
      code : 0,
      msg : 'Something went wrong and we don\'t know exactly what. If you are sure that all your data is submitted to server you can try to <a href="#" onclick="Relog(true);"sign out and sign in</a>. If you have work saved locally please contact support@wellit.no.'
    },
    SUBMIT_ERROR_DEFAULT : {
      code : 2,
      msg : 'We were able to upload your data, but something went wrong when importing it to the Wels Operator. We have logged your submit, but please contact support@wellit.no so we can see what went wrong.'
    },
    FETCH_ERROR_DEFAULT : {
      code : 3,
      msg : 'We were unable to fetch your data from Wels operator. If you are sure that all your data is submitted you can try to <a href="#" onclick="Relog(true);"sign out and sign in</a>. If you have work saved locally please contact support@wellit.no.'
    },
    PARSE_ERROR_DEFAULT : {
      code : 4,
      msg : 'We received an unexpected response from the Wels Operator.  If you are sure that all your data is submitted you can try to <a href="#" onclick="Relog(true);"sign out and sign in</a>. If you have work saved locally please contact support@wellit.no.'
    },
    NO_NETWORK : {
      code : 5,
      msg : 'No Internet connection. Data could not be sent or fetched. Save and load locally until you have a internet connection.'
    }
  };

  /**
   * Show info below menu
   * @param p_msg Message to be shown
   * @param p_type [G_MSG_TYPE_NORMAL, G_MSG_TYPE_WARNING, G_MSG_TYPE_ERROR, G_MSG_TYPE_SUCCESS]
   */
  var showMessage = function( p_msg, p_type ){
    var $l_info = $('#info');
    var $l_msg_box = '';

    var l_date = new Date();
    var l_date_str = GetFullDate( l_date );

    if( p_type == G_MSG_TYPE_NORMAL )
      $l_msg_box = $('<div class="information normalMessage">' + l_date_str + ': ' + p_msg + '</div>');
    else if( p_type == G_MSG_TYPE_WARNING )
      $l_msg_box = $('<div class="information warningMessage">' + l_date_str + ': ' + p_msg + '</div>');
    else if( p_type == G_MSG_TYPE_ERROR )
      $l_msg_box = $('<div class="information errorMessage">' + l_date_str + ': ' + p_msg + '</div>');
    else if( p_type == G_MSG_TYPE_SUCCESS )
      $l_msg_box = $('<div class="information successMessage">' + l_date_str + ': '  + p_msg + '</div>');

    $l_info.append( $l_msg_box.hide() );
    if( $l_info.children().length > G_MAX_MSG_STRINGS ) {

      $l_info.find(':first-child').hide('blind', {}, 500, function(e) {
        $(this).remove();
      });
    }
    $l_msg_box.show( 'slide', {}, 500 );
  };

  /**
   * Shows default error from _errors. Used in Communication.
   * @param type Type of error [NO_RESPONSE_FROM_SERVER etc].
   */
  var showDefaultError = function(type){
    if(type.msg !== null) {
        showError(type.msg);
    }
  };

  /**
   * Utility for showMessage type Error.
   * @param msg Message
   */
  var showError = function(msg){
    showMessage(msg, G_MSG_TYPE_ERROR);
  };

  return {
    showMessage: showMessage,
    showError : showError,
    showDefaultError : showDefaultError,
    errors : _errors
  }
})();

